var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1744_3947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.960938C5.90842 0.960938 0.959961 5.9094 0.959961 12.0009C0.959961 18.0925 5.90842 23.0409 12 23.0409C18.0915 23.0409 23.04 18.0925 23.04 12.0009C23.04 5.9094 18.0915 0.960938 12 0.960938ZM12 1.92094C17.5727 1.92094 22.08 6.42822 22.08 12.0009C22.08 17.5737 17.5727 22.0809 12 22.0809C6.42725 22.0809 1.91996 17.5737 1.91996 12.0009C1.91996 6.42822 6.42725 1.92094 12 1.92094ZM10.08 4.80094V6.24094H7.67996V17.7609H10.08V19.2009H11.04V17.7609H12V19.2009H12.96V17.7563C14.0631 17.725 16.7043 17.4158 16.7043 14.4966C16.7043 12.4806 14.9756 11.8091 14.2556 11.7131V11.6653C14.5916 11.5693 16.2721 11.0411 16.2721 9.07312C16.2721 6.61816 13.947 6.29443 12.96 6.25125V4.80094H12V6.24094H11.04V4.80094H10.08ZM8.78434 7.15312H12.5756C14.3036 7.15312 15.1678 7.87313 15.1678 9.31312C15.1678 9.60112 15.1203 9.84094 15.0243 10.0809C14.9283 10.3209 14.7363 10.5133 14.5443 10.7053C14.3043 10.8973 14.0638 11.0406 13.7278 11.1366C13.3918 11.2326 13.0076 11.2809 12.5756 11.2809H8.78434V7.15312ZM8.78434 12.2409H12.5756C13.5356 12.2409 14.3041 12.4326 14.8321 12.8166C15.3601 13.2006 15.6 13.7766 15.6 14.4966C15.6 14.9766 15.504 15.3607 15.36 15.6487C15.168 15.9367 14.9758 16.1767 14.6878 16.3687C14.3998 16.5608 14.1118 16.7051 13.7278 16.7531C13.3918 16.8011 13.0076 16.8488 12.5756 16.8488H8.78434V12.2409Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1744_3947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.d313bbbb7ec616ac8d0f77375299ab2d.svg";
export { ForwardRef as ReactComponent };